module.exports = __webpack_public_path__ + "static/media/d5ru.3e797087.pdf";